export const anomalisaToken = "0ff8525c-e44a-414b-abd2-e2c905ffab52";
